import "core-js/modules/es.array.reverse.js";
var _dec, _class, _descriptor, _dec2, _dec3, _class2, _descriptor2, _descriptor3, _descriptor4, _class3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import i18next from "i18next";
import { action, computed, observable, makeObservable } from "mobx";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import ViewerMode from "../../../../Models/ViewerMode";
import { GLYPHS, Icon } from "../../../../Styled/Icon";
import MapNavigationItemController from "../../../../ViewModels/MapNavigation/MapNavigationItemController";
import MapIconButton from "../../../MapIconButton/MapIconButton";
import { jsx as _jsx } from "react/jsx-runtime";
export const AR_TOOL_ID = "AR_TOOL";
async function requestDeviceMotionPermission() {
  const requestPermission = window.DeviceMotionEvent && typeof DeviceMotionEvent.requestPermission === "function" ? DeviceMotionEvent.requestPermission : () => Promise.resolve("granted");
  return requestPermission();
}
async function requestDeviceOrientationPermission() {
  const requestPermission = window.DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission === "function" ? DeviceOrientationEvent.requestPermission : () => Promise.resolve("granted");
  return requestPermission();
}
export let AugmentedVirtualityController = (_dec = action.bound, _class = class AugmentedVirtualityController extends MapNavigationItemController {
  constructor(props) {
    super();
    this.props = props;
    _initializerDefineProperty(this, "experimentalWarningShown", _descriptor, this);
    makeObservable(this);
  }
  get active() {
    return this.props.augmentedVirtuality.active;
  }
  get glyph() {
    return this.active ? GLYPHS.arOn : GLYPHS.arOff;
  }
  get viewerMode() {
    return ViewerMode.Cesium;
  }
  activate() {
    // Make the AugmentedVirtuality module avaliable elsewhere.
    this.props.terria.augmentedVirtuality = this.props.augmentedVirtuality;
    // feature detect for new ios 13
    // it seems you don't need to ask for both, but who knows, ios 14 / something
    // could change again
    requestDeviceMotionPermission().then(permissionState => {
      if (permissionState !== "granted") {
        console.error("couldn't get access for motion events");
      }
    }).catch(console.error);
    requestDeviceOrientationPermission().then(permissionState => {
      if (permissionState !== "granted") {
        console.error("couldn't get access for orientation events");
      }
    }).catch(console.error);
    const {
      experimentalWarning = true
    } = this.props;
    if (experimentalWarning !== false && !this.experimentalWarningShown) {
      this.experimentalWarningShown = true;
      this.props.viewState.terria.notificationState.addNotificationToQueue({
        title: i18next.t("AR.title"),
        message: i18next.t("AR.experimentalFeatureMessage"),
        confirmText: i18next.t("AR.confirmText")
      });
    }
    this.props.augmentedVirtuality.activate();
  }
  deactivate() {
    this.props.augmentedVirtuality.deactivate();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "experimentalWarningShown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "active", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "active"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activate", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "activate"), _class.prototype), _class);
export let AugmentedVirtualityRealignController = (_dec2 = action.bound, _dec3 = action.bound, _class2 = class AugmentedVirtualityRealignController extends MapNavigationItemController {
  constructor(props) {
    super();
    this.props = props;
    _initializerDefineProperty(this, "experimentalWarningShown", _descriptor2, this);
    _initializerDefineProperty(this, "realignHelpShown", _descriptor3, this);
    _initializerDefineProperty(this, "resetRealignHelpShown", _descriptor4, this);
    _defineProperty(this, "augmentedVirtuality", void 0);
    makeObservable(this);
    this.augmentedVirtuality = props.augmentedVirtuality;
  }
  get glyph() {
    return !this.augmentedVirtuality.manualAlignmentSet ? GLYPHS.arRealign : GLYPHS.arResetAlignment;
  }
  get viewerMode() {
    return ViewerMode.Cesium;
  }
  get visible() {
    return this.props.augmentedVirtuality.active && super.visible;
  }
  handleClick() {
    if (!this.augmentedVirtuality.manualAlignmentSet) {
      this.handleClickRealign();
    } else if (!this.augmentedVirtuality.manualAlignment) {
      this.handleClickResetRealign();
    }
  }
  handleClickRealign() {
    if (!this.realignHelpShown) {
      this.realignHelpShown = true;
      this.props.viewState.terria.notificationState.addNotificationToQueue({
        title: i18next.t("AR.manualAlignmentTitle"),
        message: i18next.t("AR.manualAlignmentMessage", {
          img: '<img width="100%" src="./build/TerriaJS/images/ar-realign-guide.gif" />'
        }),
        confirmText: i18next.t("AR.confirmText")
      });
    }
    this.augmentedVirtuality.toggleManualAlignment();
  }
  handleClickResetRealign() {
    if (!this.resetRealignHelpShown) {
      this.resetRealignHelpShown = true;
      this.props.viewState.terria.notificationState.addNotificationToQueue({
        title: i18next.t("AR.resetAlignmentTitle"),
        message: i18next.t("AR.resetAlignmentMessage"),
        confirmText: i18next.t("AR.confirmText")
      });
    }
    this.augmentedVirtuality.resetAlignment();
  }
}, _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "experimentalWarningShown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "realignHelpShown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "resetRealignHelpShown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "glyph", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "glyph"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "visible", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "visible"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleClickRealign", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "handleClickRealign"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleClickResetRealign", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "handleClickResetRealign"), _class2.prototype), _class2);
export const AugmentedVirtualityRealign = observer(props => {
  const augmentedVirtuality = props.arRealignController.augmentedVirtuality;
  const realignment = augmentedVirtuality.manualAlignment;
  const {
    t
  } = useTranslation();
  return !augmentedVirtuality.manualAlignmentSet ? /*#__PURE__*/_jsx(StyledMapIconButton, {
    noExpand: true,
    blink: realignment,
    iconElement: () => /*#__PURE__*/_jsx(Icon, {
      glyph: GLYPHS.arRealign
    }),
    title: t("AR.btnRealign"),
    onClick: props.arRealignController.handleClickRealign
  }) : /*#__PURE__*/_jsx(MapIconButton, {
    noExpand: true,
    iconElement: () => /*#__PURE__*/_jsx(Icon, {
      glyph: GLYPHS.arResetAlignment
    }),
    title: t("AR.btnResetRealign"),
    onClick: props.arRealignController.handleClickResetRealign
  });
});
export let AugmentedVirtualityHoverController = (_class3 = class AugmentedVirtualityHoverController extends MapNavigationItemController {
  constructor(props) {
    super();
    this.props = props;
    makeObservable(this);
  }
  get glyph() {
    const hoverLevel = this.props.augmentedVirtuality.hoverLevel;
    // Note: We use the image of the next level that we will be changing to, not the level the we are currently at.
    switch (hoverLevel) {
      case 0:
        return GLYPHS.arHover0;
      case 1:
        return GLYPHS.arHover1;
      case 2:
        return GLYPHS.arHover2;
      default:
        return GLYPHS.arHover0;
    }
  }
  get viewerMode() {
    return ViewerMode.Cesium;
  }
  get visible() {
    return this.props.augmentedVirtuality.active && super.visible;
  }
  handleClick() {
    this.props.augmentedVirtuality.toggleHoverHeight();
  }
}, _applyDecoratedDescriptor(_class3.prototype, "visible", [computed], Object.getOwnPropertyDescriptor(_class3.prototype, "visible"), _class3.prototype), _class3);
const StyledMapIconButton = styled(MapIconButton).withConfig({
  displayName: "AugmentedVirtualityTool__StyledMapIconButton",
  componentId: "sc-1tzwogc-0"
})(["svg{", "}@-moz-keyframes blinker{0%{opacity:1;}50%{opacity:0;}100%{opacity:1;}}@-webkit-keyframes blinker{0%{opacity:1;}50%{opacity:0;}100%{opacity:1;}}@keyframes blinker{0%{opacity:1;}50%{opacity:0;}100%{opacity:1;}}"], p => p.blink && "\n      -webkit-animation-name: blinker;\n      -webkit-animation-duration: 1s;\n      -webkit-animation-timing-function: linear;\n      -webkit-animation-iteration-count: infinite;\n\n      -moz-animation-name: blinker;\n      -moz-animation-duration: 1s;\n      -moz-animation-timing-function: linear;\n      -moz-animation-iteration-count: infinite;\n\n      animation-name: blinker;\n      animation-duration: 1s;\n      animation-timing-function: linear;\n      animation-iteration-count: infinite;\n    ");